import React, { createContext, useContext, useState } from 'react';

const FilterContext = createContext(null);

export const FilterProvider = ({ children }) => {
  const [species, setSpecies] = useState(['All']);
  const [caseType, setCaseType] = useState('All');

  const toggleSpecies = (name) => {
    if (name === 'All') {
      setSpecies(['All']);
      return;
    }

    setSpecies((prev) => {
      // Remove 'All' if it's there
      const filtered = prev.filter((s) => s !== 'All');
      
      if (filtered.includes(name)) {
        const next = filtered.filter((s) => s !== name);
        return next.length === 0 ? ['All'] : next;
      } else {
        return [...filtered, name];
      }
    });
  };

  return (
    <FilterContext.Provider value={{ species, toggleSpecies, caseType, setCaseType }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilters = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilters must be used within a FilterProvider');
  }
  return context;
};
